import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/BlogCreateForm.css"; // External CSS for custom styles
import LayOut from "../../components/LayOut";
import axios from "axios";
import toast from "react-hot-toast";

const BlogCreateForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    author: "",
    description: "",
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      image: e.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.author ||
      !formData.description ||
      !formData.image
    ) {
      return toast.error("All fields are required!");
    }
    try {
      const BlogFormData = new FormData();
      BlogFormData.append("name", formData.name);
      BlogFormData.append("author", formData.author);
      BlogFormData.append("description", formData.description);
      BlogFormData.append("image", formData.image);
      const responce = await axios.post(
        "https://portfoliomern-mxue.onrender.com/api/v1/blog/create-blog",
        BlogFormData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (responce.data.success) {
        toast.success("Blog Created Successfully");
        setFormData({
          name: "",
          author: "",
          description: "",
          image: null,
        });
      } else {
        toast.error(responce.data.message || "Failed to create blog");
      }
    } catch (error) {
      toast.error("Something went wrong while creating blog");
    }
  };

  return (
    <LayOut title={"Blog Page"}>
      <div
        className="blog-create-form d-flex justify-content-center align-items-center"
        style={{ backgroundColor: "#1c1c1c", minHeight: "100vh" }}
      >
        <form
          onSubmit={handleSubmit}
          className="p-4 shadow rounded"
          style={{
            backgroundColor: "#2b2b2b",
            width: "100%",
            maxWidth: "500px",
          }}
        >
          {/* Image Upload */}
          <div className="form-group mb-3">
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={handleImageChange}
            />
          </div>

          {/* Name Input */}
          <div className="form-group mb-3">
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Blog Name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          {/* Author Input */}
          <div className="form-group mb-3">
            <input
              type="text"
              name="author"
              className="form-control"
              placeholder="Author Name"
              value={formData.author}
              onChange={handleChange}
            />
          </div>

          {/* Description Text Area */}
          <div className="form-group mb-3">
            <textarea
              name="description"
              rows="5"
              className="form-control"
              placeholder="Blog Description"
              value={formData.description}
              onChange={handleChange}
            ></textarea>
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn btn-pink w-100">
            Create
          </button>
        </form>
      </div>
    </LayOut>
  );
};

export default BlogCreateForm;
